import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { User } from 'types/schema-generated-types';
import Pin from 'components/@common/Pin';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      padding: theme.spacing(3),
      display: 'flex'
    },
    role: {
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      backgroundColor: '#BB6577',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      textTransform: 'uppercase'
    },
    avatarContainer: {
      display: 'flex',
      verticalAlign: 'middle',
      alignItems: 'center'
    },
    avatar: {
      height: theme.spacing(16),
      width: theme.spacing(16),
      fontSize: theme.typography.h1.fontSize
    },
    informationContainer: {
      display: 'flex',
      flex: 1
    },
    actionsContainer: {
      display: 'flex'
    },
    detailContainer: {
      marginLeft: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  };
});

interface UserInformationProps
  extends Pick<User, 'firstName' | 'lastName' | 'avatarUrl' | 'type' | 'username' | 'pin'> {
  organizations?: string;
}

const UserInformation: React.FC<UserInformationProps> = ({
  avatarUrl,
  firstName,
  lastName,
  organizations,
  pin,
  username
}) => {
  const classes = useStyles();
  const { t } = useTranslation('UserInformation');
  const userInitials = firstName.charAt(0) + lastName.charAt(0);
  const history = useHistory();

  const handleProfileClick = (): void => {
    history.push('/profile');
  };
  return (
    <Paper className={classes.root} elevation={3}>
      <div className={classes.informationContainer}>
        <div className={classes.avatarContainer}>
          <Avatar alt={`${firstName} ${lastName}`} src={avatarUrl || ''} className={classes.avatar}>
            {userInitials}
          </Avatar>
        </div>
        <div className={classes.detailContainer}>
          <Typography variant="h2">
            {`${t('Hi')}, `} {firstName || lastName ? `${firstName || ''} ${lastName || ''}` : ''}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {username}
          </Typography>
          {pin && <Pin pin={pin} />}
          <Typography variant="subtitle1" color="textSecondary">
            {organizations}
          </Typography>
        </div>
      </div>
      <div className={classes.actionsContainer}>
        <Button
          variant="outlined"
          disableElevation
          size="small"
          onClick={handleProfileClick}
          aria-label={t('View Profile')}
          startIcon={<ArrowForwardIcon />}
        >
          <span>{t('View Profile')}</span>
        </Button>
      </div>
    </Paper>
  );
};

export default UserInformation;
